import moment from "moment-timezone";

import { REGISTER_TRADEMARK_CODE_ARRAY } from "_constants";

export function getProcessingSpeed(products) {
  const isRush = products.some(({ code: { code } }) => code === "TRADEMARK_Trademark_Rush_Processing");

  return isRush ? "Rush" : "Standard";
}

export function getOrderStatus(products = []) {
  const registerProduct = products?.find(({ code: { code } }) => REGISTER_TRADEMARK_CODE_ARRAY.includes(code));
  if (registerProduct) return registerProduct?.processingResult?.status || "—";

  const displayedProduct =
    products?.find(({ code: { code } }) => code !== "TRADEMARK_Trademark_Rush_Processing") || products[0];

  return displayedProduct?.processingResult?.status || "—";
}

export function getOrderError(products = []) {
  const registerProduct = products?.find(({ code: { code } }) => REGISTER_TRADEMARK_CODE_ARRAY.includes(code));
  if (registerProduct) return registerProduct?.processingResult?.processingError || "—";

  const displayedProduct =
    products?.find(({ code: { code } }) => code !== "TRADEMARK_Trademark_Rush_Processing") || products[0];

  return displayedProduct?.processingResult?.processingError || "—";
}

export function getLogOfStatuses(products = []) {
  const registerProduct = products?.find(({ code: { code } }) => REGISTER_TRADEMARK_CODE_ARRAY.includes(code));
  if (registerProduct) return registerProduct?.processingResult?.logOfStatuses || [];

  const displayedProduct =
    products?.find(({ code: { code } }) => code !== "TRADEMARK_Trademark_Rush_Processing") || products[0];

  return displayedProduct?.processingResult?.logOfStatuses || [];
}

export function getMainProduct(products = []) {
  const hasMain = products?.some((product) => product.code.main);
  const mainProductIndex = hasMain ? products?.findIndex((product) => product.code.main) : 0;

  return products[mainProductIndex];
}

export function getProductFiles(product) {
  if (!product) return null;
  const id = product.id;
  const files = product.processingResult.files;
  return Object.keys(files)
    .map((key) => ({ filename: key, uploaded: files[key].uploaded, productId: id }))
    .flat()
    .sort((cur, next) => {
      const curDate = moment(cur.uploaded).valueOf();
      const nextDate = moment(next.uploaded).valueOf();
      if (Number.isNaN(nextDate) || (Number.isNaN(nextDate) && Number.isNaN(curDate))) return -1;
      if (Number.isNaN(curDate)) return 1;
      return curDate - nextDate;
    });
}

export function getProductsFiles(products, codesToHide = [], codesToShow = [], sorting = "BY_DATE") {
  if (!products || products?.length < 1) return null;

  return products
    .map(({ processingResult: { files }, id }) =>
      Object.keys(files)
        .filter((key) => {
          if (codesToShow.length > 0) {
            return codesToShow.includes(files[key]?.type);
          } else {
            return !codesToHide.includes(files[key]?.type);
          }
        })
        .map((key) => ({
          ...files[key],
          productId: id,
          filename: key,
          uploaded: files[key]?.uploaded,
          type: files[key]?.type,
        }))
    )
    .flat()
    .filter((file) => {
      if (codesToShow.length < 1) {
        return true;
      }

      return codesToShow.includes(file?.type);
    })
    .sort((cur, next) => {
      const curDate = moment(cur.uploaded).valueOf();
      const nextDate = moment(next.uploaded).valueOf();

      switch (sorting) {
        case "BY_DATE":
          if (Number.isNaN(nextDate) || (Number.isNaN(nextDate) && Number.isNaN(curDate))) return -1;
          if (Number.isNaN(curDate)) return 1;
          return curDate - nextDate;

        case "BY_TYPE":
          if (cur?.type < next?.type) return -1;
          if (cur?.type > next?.type) return 1;
          return 0;

        default:
          return 0;
      }
    });
}

export function getProductMailFiles(product) {
  if (!product) return null;
  const id = product.id;
  const files = product.processingResult.files;
  return Object.keys(files)
    .filter((key) => files[key].type === "TRADEMARK_MAIL")
    .map((key) => ({
      filename: key,
      customerName: files[key].ourFileName,
      note: files[key].note,
      uploaded: files[key].uploaded,
      productId: id,
    }))
    .flat()
    .sort((cur, next) => {
      const curDate = moment(cur.uploaded).valueOf();
      const nextDate = moment(next.uploaded).valueOf();
      if (Number.isNaN(nextDate) || (Number.isNaN(nextDate) && Number.isNaN(curDate))) return -1;
      if (Number.isNaN(curDate)) return 1;
      return curDate - nextDate;
    });
}
